import React from 'react';
import * as styles from './styles.scss';

const Thumbnail = ({ children }) => (children);

const Slide = ({ children }) => (
    <div className={styles.slide}>
        {children}
    </div>
);

const Category = ({ children }) => (
    <div className={styles.category}>
        {children}
    </div>
);

const Product = ({ children }) => (
    <div className={styles.product}>
        {children}
    </div>
);

const Recipe = ({ children }) => (
    <div className={styles.recipe}>
        {children}
    </div>
);

const Gallery = ({ children }) => (
    <div className={styles.gallery}>
        {children}
    </div>
);

Thumbnail.Slide = Slide;
Thumbnail.Category = Category;
Thumbnail.Product = Product;
Thumbnail.Recipe = Recipe;
Thumbnail.Gallery = Gallery;

export default Thumbnail;
